export default Object.freeze([
	{
		label: '12:00 a.m.',
		value: '0',
	},
	{
		label: '1:00 a.m.',
		value: '1',
	},
	{
		label: '2:00 a.m.',
		value: '2',
	},
	{
		label: '3:00 a.m.',
		value: '3',
	},
	{
		label: '4:00 a.m.',
		value: '4',
	},
	{
		label: '5:00 a.m.',
		value: '5',
	},
	{
		label: '6:00 a.m.',
		value: '6',
	},
	{
		label: '7:00 a.m.',
		value: '7',
	},
	{
		label: '8:00 a.m.',
		value: '8',
	},
	{
		label: '9:00 a.m.',
		value: '9',
	},
	{
		label: '10:00 a.m.',
		value: '10',
	},
	{
		label: '11:00 a.m.',
		value: '11',
	},
	{
		label: '12:00 p.m.',
		value: '12',
	},
	{
		label: '1:00 p.m.',
		value: '13',
	},
	{
		label: '2:00 p.m.',
		value: '14',
	},
	{
		label: '3:00 p.m.',
		value: '15',
	},
	{
		label: '4:00 p.m.',
		value: '16',
	},
	{
		label: '5:00 p.m.',
		value: '17',
	},
	{
		label: '6:00 p.m.',
		value: '18',
	},
	{
		label: '7:00 p.m.',
		value: '19',
	},
	{
		label: '8:00 p.m.',
		value: '20',
	},
	{
		label: '9:00 p.m.',
		value: '21',
	},
	{
		label: '10:00 p.m.',
		value: '22',
	},
	{
		label: '11:00 p.m.',
		value: '23',
	},
]);
